import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
//import ItemsAdd from "./ItemsAdd";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import Invoice from "./Invoice";
import { useLoader } from "../../Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DocumentText1 } from "iconsax-react";

function Add(props) {
  const [validated, setValidated] = useState(false);
  const [planMoveFrom, setPlantMoveFrom] = useState("");
  const [planMoveTo, setPlantMoveTo] = useState("");
  const [planLocationFrom, setPlantLoationFrom] = useState("");
  const [planLocationTo, setPlantLoationTo] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [officeLocations, setOffileLocations] = useState([]);
  //const [nameOfEquipment, setNameOfEquipment] = useState("");
  const { startLoader, stopLoader } = useLoader();
  const [isSubmit, setisSubmit] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const [formData, setFormData] = useState({
    nameOfEquipment: "",
    noOfEquipments: "",
    brand: "",
    assetModalType: "",
    assetCodeNo: "",
    assetTagNo: "",
    special: "",
    cerNo: "",
    nameOfSupplier: "",
    supplierName: "",
    poNo: "",
    poDate: "",
    commencementDate: "",
    assestLife: "",
    assestCurentValue: "",
    capitalisationEntryNo: "",
    capitalisationEntryDate: "",
    FarSrNo: "",
  });
  const [invoice, setinvoice] = useState([
    {
      supplierName: "",
      billNo: "",
      date: "",
      qty: "",
      value: "",
    },
  ]);
  const [fileUpload, setFileUpload] = useState("");

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch((err) => {
        setPlantList([]);
      });
  };
  const getOfficeLocation = () => {
    utils
      .callAPI("get", `/sales/getLocationList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          // const activeVendors = res.result.filter(
          //   (vendor) => vendor.status === '1'
          // );
          setOffileLocations([
            { id: "", name: "Select Shipping Location..." },
            ...res.result,
          ]);
        }
      })
      .catch(() => {
        setOffileLocations([]);
      });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePlantSelection = (e) => {
    const selectedPlantId = e.target.value;
    setPlantMoveFrom(selectedPlantId);
  };
  const handlePlantToSelection = (e) => {
    const selectedPlantId = e.target.value;
    setPlantMoveTo(selectedPlantId);
  };
  const handlePlantLocationFrom = (e) => {
    const selectedId = e.target.value;
    setPlantLoationFrom(selectedId);
  };
  const handlePlantLocationTo = (e) => {
    const selectedId = e.target.value;
    setPlantLoationTo(selectedId);
  };
  useEffect(() => {
    getPlantList();
    getOfficeLocation();
  }, []);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    setFileUpload(file);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setisSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      startLoader();
      const invoiceDetails = invoice.map((item, index) => ({
        id: item.id ? item?.id : 0,
        supplier_name: item.supplierName,
        bill_no: item.billNo,
        date: item.date ? moment(item.date).format("YYYY-MM-DD") : "",
        qty: item.qty,
        amount: item.value,
      }));
      const bodyFormdata = new FormData();
      if (props?.isEdit) {
        bodyFormdata.append("id", props.rowData?.id);
      }
      bodyFormdata.append("assets_id", props.rowData?.id);
      bodyFormdata.append("plant_from", planMoveFrom);
      bodyFormdata.append("plant_to", planMoveTo);
      bodyFormdata.append("location_from", planLocationFrom);
      bodyFormdata.append("location_to", planLocationTo);
      bodyFormdata.append("equipment_name", formData.nameOfEquipment);
      bodyFormdata.append("equipment_no", formData.noOfEquipments);
      bodyFormdata.append("brand", formData.brand);
      bodyFormdata.append("assets_type", formData.assetModalType);
      bodyFormdata.append("cer_no", formData.cerNo);
      bodyFormdata.append("supplier_name", formData.supplierName);
      bodyFormdata.append("po_no", formData.poNo);
      bodyFormdata.append(
        "po_date",
        moment(formData.poDate).format("YYYY-MM-DD")
      );
      bodyFormdata.append("asset_code_no", formData.assetCodeNo);
      bodyFormdata.append("asset_tag_no", formData.assetTagNo);
      bodyFormdata.append(
        "production_capitalisation_date",
        moment(formData.commencementDate).format("YYYY-MM-DD")
      );
      bodyFormdata.append("benefits_classification_category", formData.special);
      bodyFormdata.append("useful_life_assets", formData.assestLife);
      bodyFormdata.append("assets_book_value", formData.assestCurentValue);
      bodyFormdata.append(
        "capitalistion_entry_no",
        formData.capitalisationEntryNo
      );
      bodyFormdata.append(
        "capitalistion_date",
        moment(formData.capitalisationEntryDate).format("YYYY-MM-DD")
      );
      bodyFormdata.append("FAR_serial_no", formData.FarSrNo);
      bodyFormdata.append("invoice_details", JSON.stringify(invoiceDetails));

      bodyFormdata.append("order_attach", fileUpload);

      utils
        .callAPI("post", "/moveorder/save", bodyFormdata)
        .then((res) => {
          if (res) {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            stopLoader();
          } else {
            setisSubmit(false);
            stopLoader();
          }
        })
        .catch((err) => {
          stopLoader();
          setisSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      if (props.isEdit) {
        const {
          plant_from,
          plant_to,
          location_from,
          location_to,
          equipment_name,
          equipment_no,
          brand,
          assets_type,
          cer_no,
          supplier_name,
          po_no,
          po_date,
          asset_code_no,
          asset_tag_no,
          production_capitalisation_date,
          benefits_classification_category,
          useful_life_assets,
          assets_book_value,
          capitalistion_entry_no,
          capitalistion_date,
          FAR_serial_no,
          invoice_data,
        } = props.rowData;

       const parseDate = (date) => {
          return date && date !== "0000-00-00" ? new Date(date) : null;
        };

        setFormData((prevState) => ({
          ...prevState,
          nameOfEquipment: equipment_name || "",
          noOfEquipments: equipment_no || "",
          brand: brand || "",
          assetModalType: assets_type || "",
          cerNo: cer_no || "",
          supplierName: supplier_name || "",
          poNo: po_no || "",
          poDate: parseDate(po_date),
          assetCodeNo: asset_code_no || "",
          assetTagNo: asset_tag_no || "",
          commencementDate: parseDate(production_capitalisation_date),
          special: benefits_classification_category || "",
          assestLife: useful_life_assets || "",
          assestCurentValue: assets_book_value || "",
          capitalisationEntryNo: capitalistion_entry_no || "",
          capitalisationEntryDate: parseDate(capitalistion_date),
          FarSrNo: FAR_serial_no || "",
        }));

        setPlantMoveFrom(plant_from || "");
        setPlantMoveTo(plant_to || "");
        setPlantLoationFrom(location_from || "");
        setPlantLoationTo(location_to || "");
        setinvoice(
          invoice_data.map((invoice) => ({
            id: invoice.id || "",
            supplierName: invoice.supplier_name || "",
            billNo: invoice.bill_no || "",
            date: parseDate(invoice.date) || "",
            qty: invoice.qty || "",
            value: invoice.amount || "",
          }))
        );
      } else {
        const { current_assets, ...rest } = props.rowData;

        setPlantMoveFrom(current_assets?.plant_id || "");
        setPlantLoationFrom(current_assets?.location_id || "");
        setFormData({
          ...formData,
          nameOfEquipment: rest.equipment_name || "",
          assetCodeNo: rest.asset_code_no || "",
          assetTagNo: rest.asset_tag_no || "",
        });
      }
    }
  }, [props.rowData]);

  useEffect(() => {
    if (
      userProfile &&
      userProfile?.user_role[0]?.roleName === "Finance Manager" &&
      props.rowData &&
      props.isEdit
    ) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [userProfile, props.rowData]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <h4>Add Move Order</h4>
          <div className="card-header-action">
            <Link
              className="btn btn-underline me-2"
              onClick={() => props.onChange({ mode: "list" })}
            >
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="planMoveFrom"
                    label="Plant (Move From)"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      value={planMoveFrom}
                      onChange={handlePlantSelection}
                      required
                      disabled={props.isEdit}
                    >
                      <option value="">Select Plant</option>
                      {plantList.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="planMoveTo"
                    label="Plant (Move To)"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      value={planMoveTo}
                      onChange={handlePlantToSelection}
                      required
                      disabled={isDisable}
                    >
                      <option value="">Select Plant</option>
                      {plantList.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                    <RB.Form.Control.Feedback type="invalid">
                      Please select a plant location.
                    </RB.Form.Control.Feedback>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="planLocationFrom"
                    label="Location (Move From)"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="planLocationFrom"
                      value={planLocationFrom}
                      onChange={handlePlantLocationFrom}
                      required
                      disabled={props.isEdit}
                    >
                      {officeLocations.map((location) => (
                        <option key={location.id} value={location.id}>
                          {location.name}
                        </option>
                      ))}
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="planLocationTo"
                    label="Location (Move To)"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="planLocationTo"
                      value={planLocationTo}
                      onChange={handlePlantLocationTo}
                      disabled={isDisable}
                      required
                    >
                      {officeLocations.map((location) => (
                        <option key={location.id} value={location.id}>
                          {location.name}
                        </option>
                      ))}
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="nameOfEquipment"
                    className="floating-label-fancy"
                    label="Name Of Equipment ( As per FAR)"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Name Of Equipment"
                      name="nameOfEquipment"
                      value={formData.nameOfEquipment}
                      onChange={handleInputChange}
                      required
                      disabled={props.isEdit}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="brand"
                    className="floating-label-fancy"
                    label="Make / Brand ( As per FAR)"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Make / Brand"
                      name="brand"
                      disabled={isDisable}
                      value={formData.brand}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="assetModalType"
                    className="floating-label-fancy"
                    label="Asset Modal/Type"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Asset Modal/Type"
                      name="assetModalType"
                      disabled={isDisable}
                      value={formData.assetModalType}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="noOfEquipments"
                    className="floating-label-fancy"
                    label="No Of Equipments"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter No Of Equipments"
                      disabled={isDisable}
                      name="noOfEquipments"
                      value={formData.noOfEquipments}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="assetCodeNo"
                    className="floating-label-fancy"
                    label="Asset Code No."
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Asset Code No."
                      name="assetCodeNo"
                      value={formData.assetCodeNo}
                      onChange={handleInputChange}
                      disabled={props.isEdit}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="assetTagNo"
                    className="floating-label-fancy"
                    label="Asset Tag No./Equip. No."
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Asset Code No."
                      name="assetTagNo"
                      value={formData.assetTagNo}
                      onChange={handleInputChange}
                      required
                      disabled={props.isEdit}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="supplierName"
                    className="floating-label-fancy"
                    label="Name of the Supplier"
                  >
                    <RB.Form.Control
                      type="text"
                      disabled={isDisable}
                      placeholder="Enter Name of the Supplier"
                      name="supplierName"
                      value={formData.supplierName}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="special"
                    label="Special Benefits / Classification / Category, if any"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      placeholder="Enter Special Benefits / Classification / Category, if any"
                      row="4"
                      disabled={isDisable}
                      name="special"
                      value={formData.special}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="cerNo"
                    className="floating-label-fancy"
                    label="CER No. (As per FAR)"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter CER No."
                      name="cerNo"
                      value={formData.cerNo}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="poNo"
                    className="floating-label-fancy"
                    label="PO No. (As per FAR)"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter PO No."
                      name="poNo"
                      value={formData.poNo}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mt-3">
                  <DatePicker
                    selected={formData.poDate}
                    onChange={(date) =>
                      setFormData({ ...formData, poDate: date })
                    }
                    className="form-control"
                    // disabled={isDisable}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Po Date(As per FAR)"
                  />
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mt-3">
                  <DatePicker
                    selected={formData.commencementDate}
                    onChange={(date) =>
                      setFormData({ ...formData, commencementDate: date })
                    }
                    className="form-control"
                    // disabled={isDisable}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Commercial Production / Capitalisation Date"
                  />
                </div>
              </RB.Col>
              <RB.Col md={12}>
                <Invoice invoice={invoice} setinvoice={setinvoice} isDisable={isDisable}/>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="assestLife"
                    className="floating-label-fancy"
                    label="Useful Life of the Assets ( As per FAR)"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Useful Life of the Assets ( As per FAR)"
                      name="assestLife"
                      value={formData.assestLife}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="assestCurentValue"
                    className="floating-label-fancy"
                    label="Asset Book Curent Value"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Asset Book Curent Value"
                      name="assestCurentValue"
                      value={formData.assestCurentValue}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="capitalisationEntryNo"
                    className="floating-label-fancy"
                    label="Capitalistion Entry No."
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder=" Capitalistion Entry No."
                      name="capitalisationEntryNo"
                      value={formData.capitalisationEntryNo}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mt-3">
                  <DatePicker
                    selected={formData.capitalisationEntryDate}
                    onChange={(date) =>
                      setFormData({
                        ...formData,
                        capitalisationEntryDate: date,
                      })
                    }
                    className="form-control"
                    // disabled={isDisable}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Capitalistion Entry Date"
                  />
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="FarSrNo"
                    className="floating-label-fancy"
                    label="FAR Sr No."
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="FAR Sr No."
                      name="FarSrNo"
                      value={formData.FarSrNo}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <div className="mb-3">
              <label className="form-label">Asset Snap</label>
              <div className="d-flex align-items-center">
                <RB.Form.Control
                  type="file"
                  name="quotation"
                  onChange={handleFileUpload}
                  accept=".jpg,.jpeg,.png"
                  className="me-2 flex-grow-1"
                  disabled={isDisable}
                />
                {props?.isEdit && (
                  <a
                    href={props.rowData.attechPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-link p-0"
                    title="View Current AttechMent"
                  >
                    <DocumentText1 />
                  </a>
                )}
              </div>
            </div>
            <RB.Row className="mt-3">
              <RB.Col className="text-end">
                <RB.Button variant="primary" type="submit" className="mt-3">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
